import { z } from 'zod';

export const DepartmentSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});
